/**
 * Loads the Notice Editor's web fonts (Inter + JetBrains Mono).
 *
 * The source stylesheet started with
 *   `@import url('https://fonts.googleapis.com/css2?family=Inter...')`
 * which worked because that file was the first stylesheet on the page.
 *
 * In JustAct-CM this stylesheet is bundled after the app's own CSS, and the CSS spec
 * requires `@import` to precede every style rule - a remote `@import` landing mid-file
 * is silently dropped by browsers, so the fonts would never load. Injecting a plain
 * <link> at mount keeps the same fonts without touching public/index.html or the
 * existing global stylesheets.
 */

const LINK_ID = "nte-google-fonts";
const FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700" +
  "&family=JetBrains+Mono:wght@400;500&display=swap";

/** Adds the font stylesheet once; repeated calls are no-ops. */
export function ensureNoticeEditorFonts() {
  if (typeof document === "undefined") return;
  if (document.getElementById(LINK_ID)) return;

  const link = document.createElement("link");
  link.id = LINK_ID;
  link.rel = "stylesheet";
  link.href = FONT_HREF;
  document.head.appendChild(link);
}
